export type AiUsageTitleProgress = { resolved: number; total: number; failed: number; loading: boolean };

export const loadAiUsageTitleIndex = async (
  threadIds: string[],
  cache: Record<string, string>,
  fetchBatch: (ids: string[]) => Promise<Record<string, string> | null>,
  isCurrent: () => boolean,
  onBatch: (titles: Record<string, string>, progress: AiUsageTitleProgress) => void
): Promise<void> => {
  const ids = Array.from(new Set(threadIds));
  const pending = ids.filter((id) => !Object.prototype.hasOwnProperty.call(cache, id));
  let resolved = ids.length - pending.length;
  let failed = 0;
  if (!isCurrent()) return;
  onBatch({}, { resolved, total: ids.length, failed, loading: !!pending.length });
  for (let offset = 0; offset < pending.length; offset += 100) {
    if (!isCurrent()) return;
    const batch = pending.slice(offset, offset + 100);
    let response: Record<string, string> | null;
    try { response = await fetchBatch(batch); } catch { response = null; }
    if (!isCurrent()) return;
    const titles: Record<string, string> = {};
    if (response === null) failed += batch.length;
    else {
      batch.forEach((id) => { titles[id] = response![id] || ""; });
      resolved += batch.length;
    }
    onBatch(titles, { resolved, total: ids.length, failed, loading: offset + 100 < pending.length });
  }
};
